import React, { Component } from "react";

export class StudentModal extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    window.ClassModal = this;
  }
  render() {
    let { props } = this;
    let { id, title, onClose, submitButton, closeButton, resetPassword, onResetPassword } = props;
    let attrs = Object.except(props, ["id", "title", "type", "onClose"]);

    return (
      <AppModalBs id={id} title={title} onClose={onClose} submitButton={submitButton} closeButton={closeButton} resetPassword={resetPassword} onResetPassword={onResetPassword}>
        <AppFormData {...attrs} onClose={onClose}></AppFormData>
      </AppModalBs>
    );
  }
}

export default StudentModal;
